import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
var Block = /*#__PURE__*/function (_Component) {
  function Block() {
    var _this;
    _classCallCheck(this, Block);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Block, [].concat(args));
    _defineProperty(_this, "renderContent", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        headerContent = _this$props.headerContent,
        content = _this$props.content,
        time = _this$props.time,
        footerContent = _this$props.footerContent,
        image = _this$props.image;
      return /*#__PURE__*/React.createElement("div", null, headerContent ? /*#__PURE__*/React.createElement("div", {
        className: "block-header"
      }, headerContent) : null, image && image != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(\"".concat(image, "\")")
        },
        className: "block-image"
      }) : null, time ? /*#__PURE__*/React.createElement("div", {
        className: "block-time"
      }, time) : null, content ? /*#__PURE__*/React.createElement("div", {
        className: "block-content"
      }, content) : null, footerContent ? /*#__PURE__*/React.createElement("div", {
        className: "block-footer"
      }, footerContent) : null, children ? children : null);
    });
    return _this;
  }
  _inherits(Block, _Component);
  return _createClass(Block, [{
    key: "render",
    value: function render() {
      var link = this.props.link;
      return /*#__PURE__*/React.createElement("div", {
        className: "block-container",
        style: this.props.style
      }, link != null ? /*#__PURE__*/React.createElement(Link, {
        to: link
      }, this.renderContent()) : this.renderContent());
    }
  }]);
}(Component);
export var BlockWrapper = function BlockWrapper(props) {
  var columns = false;
  if (props.columns) {
    columns = props.columns;
  } else if (props.cols) {
    columns = props.cols;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "block-wrapper ".concat(columns ? 'cols-' + columns : null),
    style: props.style
  }, props.children ? props.children : null);
};
export var BlockHeader = function BlockHeader(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-header",
    style: props.style
  }, props.children ? /*#__PURE__*/React.createElement("h3", null, props.children) : null);
};
export var BlockContent = function BlockContent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-content",
    style: props.style
  }, props.children ? props.children : null);
};
export var BlockFooter = function BlockFooter(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-footer",
    style: props.style
  }, props.children ? props.children : null);
};
export var BlockTime = function BlockTime(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-time",
    style: props.style
  }, props.children ? props.children : null);
};
export default Block;